import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import AlertModal from 'shared/components/AlertModal';

import { closeAlert } from 'redux/actions/alertActions';

import LogInForm from './components/LogInForm';
import { Logo, LineColor, HeaderLogo } from './styles';

const LogIn = ({ logoSrc, secondaryColor }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { openAlert, alertType, alertMessage } = useSelector((state) => state.alertState);
  const { cusNavId, authToken } = useSelector((state) => state.auth);
  const theme = useSelector((state) => state.theme);
  const { backgroundHeader } = theme;
  const onCloseAlert = () => dispatch(closeAlert());
  useEffect(() => {
    if (cusNavId && authToken) {
      history.push('/home');
    }
  }, []);
  return (
    <div className="account">
      <div className="account__wrapper">
        <div className="account__card">
          <HeaderLogo color={backgroundHeader}>
            <Logo imageSrc={logoSrc} />
          </HeaderLogo>
          <LineColor color={secondaryColor} height={3} borderWidth={2} marginTop={18.44} />
          <LogInForm secondaryColor={secondaryColor} />
        </div>
      </div>
      <AlertModal
        type={alertType}
        isOpen={openAlert}
        toggle={onCloseAlert}
        message={alertMessage}
        okText={t('general_button_ok')}
        onOk={onCloseAlert}
      />
    </div>
  );
};

LogIn.propTypes = {
  logoSrc: PropTypes.string.isRequired,
  secondaryColor: PropTypes.string.isRequired,
};

export default LogIn;
